import { IAddressWalklist } from '../interfaces/models';
import { ID } from '@datorama/akita';
import { ColumnType, LanguagePage, PageTitles } from '../interfaces/types';
import { Entity, Column } from '../entity/index';
import { ActivityAddress } from './activityAddress';

@Entity({
  name: PageTitles.addressWalklist,
  language: LanguagePage.addressWalklist,
})
export class AddressWalklist implements IAddressWalklist {
  @Column({
    type: ColumnType.string,
    table: {
      defaultPosition: 1,
    },
  })
  serviceAddress: string;

  @Column({
    type: ColumnType.string,
    table: {
      defaultPosition: 2,
    },
  })
  postalCode: string;

  @Column({
    type: ColumnType.string,
    table: {
      defaultPosition: 3,
    },
  })
  streetNameType: string;

  @Column({
    type: ColumnType.string,
    table: {
      defaultPosition: 4,
    },
  })
  premiseType: string;

  @Column({
    type: ColumnType.string,
    table: {
      defaultPosition: 5,
    },
  })
  sayb: string;

  @Column({
    type: ColumnType.string,
    table: {
      defaultPosition: 6,
    },
  })
  doNotKnockInd: boolean;

  @Column({
    type: ColumnType.string,
    table: {
      defaultPosition: 7,
    },
  })
  walklistAssignedTo: string;

  @Column({
    type: ColumnType.string,
    table: {
      defaultPosition: 8,
    },
  })
  derivedDpStatus: string;

  id: ID;
  unitNumber: string;
  streetNumber: string;
  suffix: string;
  dirPrefix: string;

  dirSuffix: string;

  permissionStatus: string;
  walklistAssigned: boolean;
  checked: boolean;
  searchStreet: string;

  walklistId: number;
  walklistCreationAt: Date;
  walklistModifiedAt: Date;
  walklistCreatedBy: string;
  walklistModifiedBy: string;
  walklistActive: boolean;

  streetName?: string;
  city?: string;
  province?: string;
  streetTypeSuffix?: string;
  fsa: string;

  totalFeatures: number;

  constructor(
    addressWalklist: IAddressWalklist = {
      id: '',
      serviceAddress: '',
      postalCode: '',
      unitNumber: '',
      streetNumber: '',
      suffix: '',
      dirPrefix: '',
      streetNameType: '',
      dirSuffix: '',
      premiseType: '',
      sayb: '',
      permissionStatus: '',
      walklistAssigned: false,
      checked: false,
      searchStreet: '',
      walklistAssignedTo: '',
      walklistId: 0,
      walklistCreationAt: new Date(),
      walklistModifiedAt: null,
      walklistCreatedBy: '',
      walklistModifiedBy: '',
      walklistActive: false,
      derivedDpStatus: null,
      doNotKnockInd: null,
      totalFeatures: 0,
      streetName: '',
      city: '',
      province: '',
      streetTypeSuffix: '',
      fsa: '',
    }
  ) {
    const {
      id,
      serviceAddress,
      postalCode,
      unitNumber,
      streetNumber,
      suffix,
      dirPrefix,
      streetNameType,
      dirSuffix,
      premiseType,
      sayb,
      permissionStatus,
      walklistAssigned,
      checked,
      searchStreet,
      walklistAssignedTo,
      walklistId,
      walklistCreationAt,
      walklistModifiedAt,
      walklistCreatedBy,
      walklistModifiedBy,
      walklistActive,
      derivedDpStatus,
      doNotKnockInd,
      totalFeatures,
      streetName,
      city,
      province,
      streetTypeSuffix,
      fsa,
    } = addressWalklist;

    this.id = id;
    this.serviceAddress = serviceAddress;
    this.postalCode = postalCode;
    this.unitNumber = unitNumber;
    this.streetNumber = streetNumber;
    this.suffix = suffix;
    this.dirPrefix = dirPrefix;
    this.streetNameType = streetNameType;
    this.dirSuffix = dirSuffix;
    this.premiseType = premiseType;
    this.sayb = sayb;
    this.permissionStatus = permissionStatus;
    this.walklistAssigned = walklistAssigned;
    this.checked = checked;
    this.searchStreet = searchStreet;
    this.walklistAssignedTo = walklistAssignedTo;
    this.walklistId = walklistId;
    this.walklistCreationAt = walklistCreationAt;
    this.walklistModifiedAt = walklistModifiedAt;
    this.walklistCreatedBy = walklistCreatedBy;
    this.walklistModifiedBy = walklistModifiedBy;
    this.walklistActive = walklistActive;
    this.derivedDpStatus = derivedDpStatus;
    this.doNotKnockInd = doNotKnockInd;
    this.totalFeatures = totalFeatures;
    this.streetName = streetName;
    this.city = city;
    this.province = province;
    this.streetTypeSuffix = streetTypeSuffix;
    this.fsa = fsa;
  }
}
